import { chain, isString, flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import ButtonGroup from '../button-group';
import ModalHeader from '../modals/base/modal-header';
import withFontClassName from '../../hoc/with-font-class-name';
import withTranslate from '../../hoc/with-translate';
import styles from './move-to-category.scss';
import RadioList from '../radio-list';

class MoveToCategory extends Component {
  state = {};
  constructor(props) {
    super(props);

    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);

    const categories = this.props.categories.filter(
      category => category._id !== this.props.currentCategoryId,
    );
    this.state = {
      categoryId: categories.length ? categories[0]._id : null,
    };
  }

  handleCategoryChange(categoryId) {
    this.setState({ categoryId });
  }

  handleMove() {
    this.props.onClick(this.state.categoryId);
  }

  handleCancelClick() {
    this.props.onCancel();
  }

  render() {
    const { contentFontClassName, t, categories, currentCategoryId } = this.props;
    const className = classNames(
      contentFontClassName,
      'default-desktop-header-text-color',
      'move-to-category',
    );
    const options = chain(categories)
      .filter(category => category._id !== currentCategoryId)
      .map(category => ({
        label: category.label,
        value: category._id,
        isIndented: isString(category.parentId),
      }))
      .value();
    return (
      <div className={className}>
        <ModalHeader>{t('move-to-category.move-to-category')}</ModalHeader>
        <div className={styles.message}>{this.props.message}</div>
        <div className={styles.selectWrapper}>
          <RadioList
            options={options}
            value={this.state.categoryId}
            onChange={this.handleCategoryChange}
          />
        </div>
        <ButtonGroup
          primaryButtonText={t('move-to-category.move-post')}
          primaryButtonProps={{ onClick: this.handleMove }}
          secondaryButtonText={t('move-to-category.cancel')}
          secondaryButtonProps={{ onClick: this.handleCancelClick }}
          isCentered
        />
      </div>
    );
  }
}

MoveToCategory.propTypes = {
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  currentCategoryId: PropTypes.string,
  message: PropTypes.string,
};

export default flowRight(
  withFontClassName,
  withTranslate,
)(MoveToCategory);
